import * as React from 'react';
import { PinterestEmbed } from 'react-social-media-embed';
import { SocialEmbedContainer } from '../socialEmbedContainer';
export var Pinterest = function (props) {
    var link = props.link;
    return (React.createElement(SocialEmbedContainer, null,
        React.createElement(PinterestEmbed, { url: link, width: "100%" })));
};
